// eslint-disable-next-line import/prefer-default-export
export const CONTROLS_PLACEMENTS = {
  rightSide: 'rightSide',
  bothSides: 'bothSides',
};
